import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconArrow as IconArrowIcon } from 'common/components/svgs';

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.marginPagesDisplayed = 1;
    this.pageRangeDisplayed = 3;
  }

  shouldComponentUpdate(prevProp) {
    return (
      prevProp.totalPage !== this.props.totalPage || prevProp.currentPage !== this.props.currentPage
    );
  }

  handlePageSelected(page) {
    if (page === 0 || page > this.props.totalPage || page === this.props.currentPage) {
      return;
    }
    this.props.onPageClick(page);
  }

  pagination = () => {
    const items = [];
    if (this.props.totalPage <= this.pageRangeDisplayed) {
      for (let index = 1; index <= this.props.totalPage; index++) {
        items.push({
          page: index,
          type: 'page',
          property: {
            selected: index === this.props.currentPage,
          },
        });
      }
    } else {
      let leftSide = this.pageRangeDisplayed / 2;
      let rightSide = this.pageRangeDisplayed - leftSide;

      if (this.props.currentPage > this.props.totalPage - this.pageRangeDisplayed / 2) {
        rightSide = this.props.totalPage - this.props.currentPage;
        leftSide = this.pageRangeDisplayed - rightSide;
      } else if (this.props.currentPage < this.pageRangeDisplayed / 2) {
        leftSide = this.props.currentPage;
        rightSide = this.pageRangeDisplayed - leftSide;
      }

      for (let index = 1; index <= this.props.totalPage; index++) {
        if (
          index > this.props.totalPage - this.marginPagesDisplayed ||
          (index >= this.props.currentPage - leftSide &&
            index <= this.props.currentPage + rightSide) ||
          index <= this.marginPagesDisplayed
        ) {
          items.push({
            page: index,
            type: 'page',
            property: {
              selected: index === this.props.currentPage,
            },
          });
        } else {
          const breakLabelValue = items[items.length - 1].type;
          if (breakLabelValue !== 'break') {
            items.push({
              page: index,
              type: 'break',
            });
          }
        }
      }
    }

    return items;
  };

  render() {
    return (
      <ul className="pagination" role="menu">
        <li
          role="menuitem"
          onClick={() => {
            this.handlePageSelected(this.props.currentPage - 1);
          }}
          className={classNames('pagination__previous', {
            disabled: this.props.currentPage === 1,
          })}
        >
          <IconArrowIcon className="pagination__svg" />
        </li>

        <For each="item" of={this.pagination()}>
          <Choose>
            <When condition={item.type === 'break'}>
              <li role="menuitem" className="pagination__break" key={item.page}>
                ...
              </li>
            </When>
            <Otherwise>
              <li
                role="menuitem"
                key={item.page}
                onClick={() => {
                  this.handlePageSelected(item.page);
                }}
                className={classNames('pagination__item', {
                  'pagination__item--active': item.property.selected,
                })}
              >
                {item.page}
              </li>
            </Otherwise>
          </Choose>
        </For>

        <li
          role="menuitem"
          onClick={() => {
            this.handlePageSelected(this.props.currentPage + 1);
          }}
          className={classNames('pagination__next', {
            disabled: this.props.currentPage === this.props.totalPage,
          })}
        >
          <IconArrowIcon className="pagination__svg" />
        </li>
      </ul>
    );
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  onPageClick: PropTypes.func.isRequired,
};

export default Pagination;
